import React from 'react';
import { PreAuthNavbar } from '@/components/navigation/PreAuthNavbar';
import { Hero } from '@/components/marketing/Hero';
import { FeatureGrid } from '@/components/marketing/FeatureGrid';
import { PricingTiers } from '@/components/marketing/PricingTiers';
// import { WaitlistForm } from '@/components/marketing/WaitlistForm';
import { Footer } from '@/components/marketing/Footer';
import { FAQAccordion } from '@/components/marketing/FAQAccordion';

export const Landing: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <PreAuthNavbar />
            <main className="flex-1">
                <Hero />
                <FeatureGrid />
                <section id="pricing" className="mx-auto w-full max-w-6xl px-4">
                    <PricingTiers inLanding />
                </section>
                {/* <section className="mx-auto max-w-6xl px-4 flex flex-col items-center py-20">
                    <h2 className="text-2xl sm:text-3xl font-bold tracking-tight mb-4">Join the waitlist</h2>
                    <p className="text-muted-foreground mb-6 text-center max-w-md">We're onboarding users gradually. Start with individual interviews, scale to team collaboration.</p>
                    <WaitlistForm />
                </section> */}
                <section id="faq" className="mx-auto max-w-5xl px-4 py-20">
                    <FAQAccordion />
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default Landing;
